atcPaymentType.$inject = ['paymentTypes', '$filter'];

/* @ngInject */
function atcPaymentType(paymentTypes, $filter) {

    return {
        restrict: 'A',
        require: 'select',
        link: function (scope, element, attrs, selectController) {
            paymentTypes.forEach(option => {
                const optionElement = angular.element('<option/>')
                    .attr('value', option)
                    .text($filter('humanize')(option, 'payment_type'));
                selectController.addOption(option, optionElement);
                element.append(optionElement);
            });
        }
    };
}

export default atcPaymentType;